import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
export function TruthSection() {
  return <section className="py-16 px-4 bg-[#FFF8F0]" data-id="element-523" data-mp="3gw5yausnt4ck">
      <div className="max-w-lg md:max-w-2xl mx-auto" data-id="element-524" data-mp="3bvrp39fbnocy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-525" data-mp="3bugotjl34yql">
          <div className="flex justify-center mb-6" data-id="element-526" data-mp="2y4d6v4t8nr6y">
            <div className="bg-[#FFF9C4] p-4 rounded-full shadow-sm" data-id="element-527" data-mp="2y3lb9tzn5tgo">
              <Lightbulb className="w-8 h-8 text-[#F57F17]" data-id="element-528" data-mp="2t4h0x00zdpor" />
            </div>
          </div>

          <h2 className="text-2xl md:text-4xl font-black text-center text-gray-900 mb-10" data-id="element-529" data-mp="2o6p7u2olnxiz">
            LA VERDAD QUE NADIE TE CUENTA
          </h2>

          <div className="space-y-6 text-gray-700 text-lg" data-id="element-530" data-mp="2j6axuf3fudib">
            <p data-id="element-531" data-mp="2f590y4wzudji">
              Hay una razón muy concreta por la que esto pasa. Y no tiene que
              ver con que seas mala cocinera, ni con que tu hijo sea "difícil",
              ni con que la alimentación saludable sea imposible en la vida
              real.
            </p>

            <div className="bg-white p-6 rounded-2xl shadow-sm border-l-4 border-[#4CAF50]" data-id="element-532" data-mp="frb921lwhxjf">
              <p className="text-xl font-bold text-gray-900" data-id="element-533" data-mp="kpcsinn8nyvf">
                Tiene que ver con el sistema. O más precisamente: con la falta
                de uno.
              </p>
            </div>

            <p data-id="element-534" data-mp="1df38714ir8tn">
              Cuando decides qué cocinar cinco minutos antes de hacerlo, tu
              cerebro elige lo más fácil, lo más rápido, lo que ya conoce.
            </p>

            <p data-id="element-535" data-mp="13gdsnf03i0gk">
              Cuando no hay estructura, hay caos. Y los niños —que necesitan
              predecibilidad para sentirse seguros— se defienden del caos con lo
              único que pueden controlar: lo que meten en la boca.
            </p>

            <div className="py-8" data-id="element-536" data-mp="3o860mkx8zvi7">
              <div className="relative bg-[#E8F5E9] p-8 rounded-3xl text-center" data-id="element-537" data-mp="1unw1828kb5em">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 text-4xl" data-id="element-538" data-mp="1upytksx6tami">
                  🧩
                </div>
                <p className="text-xl md:text-2xl font-bold text-[#2E7D32] italic" data-id="element-539" data-mp="1kxkpvumjttxp">
                  "El rechazo en la mesa no suele ser sobre la comida. Es sobre
                  el control. Sobre la seguridad. Sobre la falta de rutina."
                </p>
              </div>
            </div>

            <p className="text-xl font-medium text-center text-gray-900" data-id="element-540" data-mp="16xrzk0expfq9">
              Y la buena noticia es que todo eso se puede cambiar,{' '}
              <span className="text-[#4CAF50] font-bold" data-id="element-541" data-mp="11zgoxngtf16z">
                sin ser nutricionista, sin pasar horas cocinando, y sin que la
                mesa sea un examen.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}